import { Pipe, PipeTransform } from '@angular/core';
import { FreightDocument } from '../../core/models/freight-document/FreightDocument';
import { SigningAction } from '../../core/services/signing.service';
import { Role } from '../../core/models/freight-document/Role';

@Pipe({
  name: 'signingActionToSigningRole'
})
export class SigningActionToSigningRolePipe implements PipeTransform {

  transform(signingAction: SigningAction, fd: FreightDocument): Role {
    if (signingAction === SigningAction.COLLECTION) {
      return fd.placeOfTakingOver || fd.consignor
    }
    if (signingAction === SigningAction.DELIVERY) {
      return fd.placeOfDelivery|| fd.consignee
    }
    return null
  }

}
